import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import { ProfileModal } from '../components/profile-modal/profile-modal';
import RouteLoading from '../components/route-loading';
import TableFilter from '../components/table-filter';

class StaffPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  localState = observable({
    isModalOpened: false,
    selectedProfileId: null,
    currentPage: 1,
    lastFilter: { label: '-', value: 'all' },
    lastFilters: [],
  });

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
    this.localState.selectedProfileId = null;
    this.actions.staffActions.fetch();
  });

  onModalOpen = action(profileId => {
    this.localState.selectedProfileId = profileId;
    this.localState.isModalOpened = true;
  });

  saveColumnPreset = async preset => {
    await this.actions.staffActions.saveColumnPreset(preset);
  };

  onAddNew = () => {
    this.onModalOpen(-1);
  };

  onPageChange = async page => {
    this.localState.currentPage = page;
    this.lastPage = page;
    await this.actions.staffActions.refreshStaff(
      this.lastPage,
      this.lastSearch,
      this.localState.lastFilter.value,
      this.localState.lastFilters,
    );
  };

  onSearchChange = async searchString => {
    this.lastSearch = searchString;
  }

  onSearchEnter = async () => {
    if (this.localState.currentPage !== 1) {
      this.lastPage = 1;
    }

    await this.actions.staffActions.refreshStaff(
      this.lastPage,
      this.lastSearch,
      this.localState.lastFilter.value,
      this.localState.lastFilters,
    );
  };


  onFilterChange = async filterId => {
    this.localState.lastFilter = filterId;
    this.lastFilter = filterId;
    this.store.staff.filters.filtering.selected = filterId;

    await this.actions.staffActions.refreshStaff(
      this.lastPage,
      this.lastSearch,
      this.lastFilter.value,
      this.lastFilters,
    );
  };


  onChangeStaffFilters = async filters => {
    if (filters.is_new) {
      this.localState.lastFilters.push({
        type: filters.type,
        value: filters.value,
        label: filters.label,
        isServerSide: filters.isServerSide
      });

    } else {
      this.localState.lastFilters = this.localState.lastFilters.filter(filter => filter.type !== filters.type);
    }

    this.localState.lastPage = 1;

    await this.actions.staffActions.refreshStaff(
      this.localState.lastPage,
      this.localState.lastSearch,
      this.localState.lastFilter.value,
      this.localState.lastFilters,
    );
  };

  render() {
    const { filters, selectors, ui } = this.store.staff;
    const {
      setDates,
      changeGrouping,
      changeStatus,
      changeColumnPreset,
      changeColumnVisibility,
      changeRounding,
      toggleAllColumns,
      changePresetOrder,
      deletePreset
    } = this.actions.staffActions;

    return (
      <RouteLoading meta={this.store.staff.meta}>
        <div className="content">
          <Navbar />

          <div className='under-navbar-content'>
            <TableFilter
              state={filters}
              selectors={selectors}
              onDatesChange={setDates}
              onGroupingChange={changeGrouping}
              onStatusChange={changeStatus}
              onColumnPresetChange={changeColumnPreset}
              onColumnChange={changeColumnVisibility}
              onColumnPresetSubmit={this.saveColumnPreset}
              deletePreset={deletePreset}
              onIsFractionalChange={changeRounding}
              onSearchChange={this.onSearchChange}
              onFilteringChange={this.onFilterChange}
              changePresetOrder={changePresetOrder}
              onAllColumnsToggle={toggleAllColumns}
              onSearchEnter={this.onSearchEnter}
              withTransferSearch={true}
              withSearch={false}
              withoutFractionalChange
              withoutDatesChange
              withoutStatusChange
              withoutGroupingChange
              withAdd
              onAdd={this.onAddNew}
              getTableNode={() => this.node}
            />
            <div className="container">
              <div className="inner">
                <div className="inner-scroll stuff-table">
                  <Observer>
                    {() =>
                      selectors.filteredData.map((table, idx) => (
                        <DataTable
                          ref={node => (this.node = node)}
                          key={idx}
                          tableFiltersKey="staff-filters"
                          data={table}
                          columnSettings={filters.columnSettings}
                          isDecimalThunk={() => filters.isDecimal}
                          favorites={ui.favorites}
                          toggleFavorite={this.actions.staffActions.toggleFavorite}
                          requestModalOpen={this.onModalOpen}
                          initialSortingMap={{ transfer_date: 'desc' }}
                          selectors={selectors}
                          account_filters={null}
                          currentPage={table._meta.page}
                          pageSize={table._meta.page_size}
                          pages={table._meta.pages}
                          name={'staff'}
                          onPageChange={this.onPageChange}
                          onRemoveFilter={this.onChangeStaffFilters}
                          onAddFilter={this.onChangeStaffFilters}
                        />
                      ))
                    }
                  </Observer>
                  <Observer>
                    {() => (
                      <ProfileModal
                        isOpened={this.localState.isModalOpened}
                        requestClose={this.onModalClose}
                        variant="staff"
                        profileId={this.localState.selectedProfileId}
                      />
                    )}
                  </Observer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component()(StaffPage);
